import { render } from "./logout.vue?vue&type=template&id=31c27074"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\projects\\tahdir-v2\\tahdir-students-scan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__